import { render, staticRenderFns } from "./ServiceBIdLeadForm.vue?vue&type=template&id=363a2598&scoped=true&"
import script from "./ServiceBIdLeadForm.vue?vue&type=script&lang=js&"
export * from "./ServiceBIdLeadForm.vue?vue&type=script&lang=js&"
import style0 from "./ServiceBIdLeadForm.vue?vue&type=style&index=0&id=363a2598&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "363a2598",
  null
  
)

export default component.exports